import { configureStore } from '@reduxjs/toolkit';
import bellNotificationSlide from '../pages/BellNotification/bellNotificationSlide';
import businessUnitSlice from '../pages/BusinessUnit/businessUnitSlice';
import dashboardSlice from '../pages/Dashboard/dashboardSlice';
import deleteProjectDocumentSlice from '../pages/DeleteProjectDocument/deleteProjectDocumentSlice';
import loadingSlice from '../pages/Loading/loadingSlice';
import accessControlSlice from '../pages/MasterData/AccessControl/accessControlSlice';
import aimsDocumentTypeSlice from '../pages/MasterData/AimsDocumentType/aimsDocumentTypeSlice';
import approvalCodeSlice from '../pages/MasterData/ApprovalCode/approvalCodeSlice';
import approvalTypeSlice from '../pages/MasterData/ApprovalType/approvalTypeSlice';
import civilJobListSlice from '../pages/MasterData/CivilJobList/civilJobListSlice';
import contractorSlice from '../pages/MasterData/Contractor/contractorSlice';
import disciplineSlice from '../pages/MasterData/Discipline/disciplineSlice';
import documentSlice from '../pages/MasterData/Document/documentSlice';
import documentGroupSlice from '../pages/MasterData/DocumentGroup/documentGroupSlice';
import electricalListGroupSlice from '../pages/MasterData/ElectricalListGroup/electricalListGroupSlice';
import instrumentListGroupSlice from '../pages/MasterData/InstrumentListGroup/instrumentListGroupSlice';
import pipingListGroupSlice from '../pages/MasterData/PipingListGroup/pipingListGroupSlice';
import pipingModelTypeSlice from '../pages/MasterData/PipingModelType/pipingModelTypeSlice';
import pipingPlantTypeSlice from '../pages/MasterData/PipingPlantType/pipingPlantTypeSlice';
import pipingWorkTypeSlice from '../pages/MasterData/PipingWorkType/pipingWorkTypeSlice';
import projectPositionSlice from '../pages/MasterData/ProjectPosition/projectPositionSlice';
import purposeSlice from '../pages/MasterData/Purpose/purposeSlice';
import revisionSlice from '../pages/MasterData/Revision/revisionSlice';
import rotateEquipmentListSlice from '../pages/MasterData/RotateEquipmentList/rotateEquipmentListSlice';
import rotateEquipmentListGroupSlice from '../pages/MasterData/RotateEquipmentListGroup/rotateEquipmentListGroupSlice';
import rotateQuestionSlice from '../pages/MasterData/RotateQuestion/rotateQuestionSlice';
import standardWorkflowSlice from '../pages/MasterData/StandardWorkflow/standardWorkflowSlice';
import staticEquipmentListSlice from '../pages/MasterData/StaticEquipmentList/staticEquipmentListSlice';
import workflowSlice from '../pages/MasterData/Workflow/workflowSlice';
import workflowStatusSlice from '../pages/MasterData/WorkflowStatus/workflowStatusSlice';
import workflowStepSlice from '../pages/MasterData/WorkflowStep/workflowStepSlice';
import pipingProjectDetailSlice from '../pages/PipingProjectDetail/pipingProjectDetailSlice';
import usersSlice from '../pages/Project/plugAndPlayUsersSlice';
import masterDataSlice from '../pages/Project/plugAndPlayMasterDataSlice';
import projectUsersSlice from '../pages/Project/projectUsersSlice';
import documentMasterListSlice from '../pages/DocumentMasterList/documentMasterListSlice';
import projectRegisterSlice from '../pages/Project/projectRegisterSlice';
import projectSlice from '../pages/Project/projectSlice';
import projectAccessControlUserSlice from '../pages/ProjectAccessControlUser/projectAccessControlUserSlice';
import projectApprovalPeriodSlice from '../pages/ProjectApprovalPeriod/projectApprovalPeriodSlice';
import projectDocumentSlice from '../pages/ProjectDocument/projectDocumentSlice';
import projectDocumentCustomAccessControlSlice from '../pages/ProjectDocumentCustomAccessControl/projectDocumentCustomAccessControlSlice';
import projectDocumentRevisionSlice from '../pages/ProjectDocumentRevision/projectDocumentRevisionSlice';
import projectDocumentRevisionFileSlice from '../pages/ProjectDocumentRevisionFile/projectDocumentRevisionFileSlice';
import projectDocumentVersionFileSlice from '../pages/ProjectDocumentVersionFile/projectDocumentVersionFileSlice';
import projectDocumentWorkflowSlice from '../pages/ProjectDocumentWorkflow/projectDocumentWorkflowSlice';
import projectWorkflowSlice from '../pages/ProjectWorkflow/projectWorkflowSlice';
import userApprovalSlice from '../pages/UserApproval/userApprovalSlice';
import userProfileSlice from '../pages/UserProfile/userProfileSlice';

export const store = configureStore({
  reducer: {
    accessControls: accessControlSlice.reducer,
    aimsDocumentTypes: aimsDocumentTypeSlice.reducer,
    approvalCodes: approvalCodeSlice.reducer,
    approvalTypes: approvalTypeSlice.reducer,
    bellNotifications: bellNotificationSlide.reducer,
    businessUnits: businessUnitSlice.reducer,
    civilJobLists: civilJobListSlice.reducer,
    contractors: contractorSlice.reducer,
    dashboards: dashboardSlice.reducer,
    deleteProjectDocuments: deleteProjectDocumentSlice.reducer,
    disciplines: disciplineSlice.reducer,
    documents: documentSlice.reducer,
    documentGroups: documentGroupSlice.reducer,
    electricalListGroups: electricalListGroupSlice.reducer,
    instrumentListGroup: instrumentListGroupSlice.reducer,
    pipingListGroups: pipingListGroupSlice.reducer,
    pipingModelTypes: pipingModelTypeSlice.reducer,
    pipingPlantTypes: pipingPlantTypeSlice.reducer,
    pipingProjectDetails: pipingProjectDetailSlice.reducer,
    pipingWorkTypes: pipingWorkTypeSlice.reducer,
    projects: projectSlice.reducer,
    projectAccessControlUsers: projectAccessControlUserSlice.reducer,
    projectApprovalPeriods: projectApprovalPeriodSlice.reducer,
    projectDocuments: projectDocumentSlice.reducer,
    projectDocumentCustomAccessControls:
      projectDocumentCustomAccessControlSlice.reducer,
    projectDocumentRevisions: projectDocumentRevisionSlice.reducer,
    projectDocumentRevisionFiles: projectDocumentRevisionFileSlice.reducer,
    projectDocumentVersionFiles: projectDocumentVersionFileSlice.reducer,
    projectDocumentWorkflows: projectDocumentWorkflowSlice.reducer,
    projectPositions: projectPositionSlice.reducer,
    projectRegisters: projectRegisterSlice.reducer,
    projectWorkflows: projectWorkflowSlice.reducer,
    purposes: purposeSlice.reducer,
    revisions: revisionSlice.reducer,
    rotateEquipmentLists: rotateEquipmentListSlice.reducer,
    rotateEquipmentListGroups: rotateEquipmentListGroupSlice.reducer,
    rotateQuestions: rotateQuestionSlice.reducer,
    staticEquipmentLists: staticEquipmentListSlice.reducer,
    loading: loadingSlice.reducer,
    standardWorkflows: standardWorkflowSlice.reducer,
    userApprovals: userApprovalSlice.reducer,
    userProfile: userProfileSlice.reducer,
    workflows: workflowSlice.reducer,
    workflowStatuses: workflowStatusSlice.reducer,
    workflowSteps: workflowStepSlice.reducer,
    plugAndPlayUsers: usersSlice.reducer,
    plugAndPlayMasterData: masterDataSlice.reducer,
    projectUsers: projectUsersSlice.reducer,
    documentMasterList: documentMasterListSlice
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
